module.exports = __webpack_public_path__ + "img/3.63458f93.jpg";